import { NavLink } from "react-router-dom";
import ItodoImage from "../../elements/itodo-img";

function Footer() {
    return (
        <>
            <footer className="site-footer footer-dark" style={{height:'100%', direction: 'rtl'}}>
                {/* <div className="sx-f-nl-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <h2 className="sx-f-title">
                                    You too join my communities.
                                </h2>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="sx-nl-form">
                                    <form>
                                        <div className="sx-nl-form-inner">
                                            <input type="text" className="sx-nl-form-input" placeholder="infomela.Itodo@gmail.com" />
                                            <button className="sx-nl-form-btn"><i className="flaticon-back-left" /></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* FOOTER BLOCKES START */}
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* ABOUT COMPANY */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                <div className="widget widget_about">
                                    <div className="logo-footer clearfix p-b15">
                                        <NavLink to="/index" className="sx-text-primary"><ItodoImage src="images/footer-logo.png" alt="#" /></NavLink>
                                    </div>
                                    <p style={{color: 'rgba(255, 255, 255, 0.5)'}}>ویرا افزار پاسارگاد، با تمرکز بر توسعه نرم‌افزار، سامانه‌های سازمانی و راهکارهای مبتنی بر فناوری‌های پیشرفته، همراهی مطمئن برای سازمان‌ها است. تخصص ما در ارائه راه‌حل‌های هوش مصنوعی، تحلیل داده و سیستم‌های غیرمتمرکز، مسیر پیشرفت دیجیتال را برای شما هموار می‌سازد.
                                    </p>
                                    {/* <div className="widget_about-call-section">
                                        <div className="sx-f-call-icon"><i className="flaticon-telephone" /></div>
                                        <div className="sx-f-call-section">
                                            <span>شماره تلفن</span>
                                            <a href="tel:86096368">86096368</a>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            {/* EXPLORE LINKS */}
                            {/* <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6 col">
                                <div className="widget widget_services">
                                    <h4 className="sx-f-title">Explore Links</h4>
                                    <ul>
                                        <li><NavLink to="/services">Our Services</NavLink></li>
                                        <li><NavLink to="/team">Meet Our Team</NavLink></li>
                                        <li><NavLink to="/portfolio">Our Portfolio</NavLink></li>
                                        <li><NavLink to="/contact-us">Contact</NavLink></li>
                                        <li><NavLink to="/blogs">News</NavLink></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* USEFUL LINK */}
                            {/* <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6 col">
                                <div className="widget widget_services">
                                    <h4 className="sx-f-title">Useful Links</h4>
                                    <ul>
                                        <li><NavLink to="/mission">Mission &amp; Vision</NavLink></li>
                                        <li><NavLink to="/why-choose-us">Why Choose Us</NavLink></li>
                                        <li><NavLink to="/portfolio">Portfolio</NavLink></li>
                                        <li><NavLink to="/portfolio2">Case Studies</NavLink></li>
                                        <li><NavLink to="/portfolio/detail">Case Studies V2</NavLink></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* SOLUTIONS */}
                            <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6 col-12 col footer-col-3 pt-5 pe-5" >
                                <div className="widget widget_info" >
                                    {/* <h4 className="sx-f-title">اطلاعات تماس</h4>
                                    <ul>
                                        <li>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-phone" />
                                            </div>
                                            <div className="widget-info-detail" >
                                                <a href="tel:+55(66633)2566">86096368 21+</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-email" />
                                            </div>
                                            <div className="widget-info-detail">
                                                <p style={{color: 'rgba(255, 255, 255, 0.5)'}}>info.viraap.co</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-maps-and-flags" />
                                            </div>
                                            <div className="widget-info-detail">
                                                <p style={{color: 'rgba(255, 255, 255, 0.5)'}}>تهران، کارگر شمالی، خیابان نهم، پلاک 82، واحد1</p>
                                            </div>
                                        </li>
                                    </ul> */}
                                    <h4 className="sx-f-title">اطلاعات تماس</h4>
                                    <ul style={{
                                        display: 'flex',  // آیتم‌ها به‌صورت افقی کنار هم
                                        justifyContent: 'space-between',  // فاصله یکنواخت بین آیتم‌ها
                                        alignItems: 'center',  // تراز وسط عمودی
                                        gap: '20px',  // فاصله بین آیتم‌ها
                                        listStyle: 'none',  // حذف نقطه‌گذاری پیش‌فرض
                                        padding: 0,  // حذف حاشیه داخلی
                                        margin: 0,  // حذف حاشیه خارجی
                                    }}>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: '10px' ,width:'20%'}}>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-phone" />
                                            </div>
                                            <div className="widget-info-detail">
                                                <a href="tel:+55(66633)2566">86096368 21+</a>
                                            </div>
                                        </li>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-email" />
                                            </div>
                                            <div className="widget-info-detail">
                                                <p style={{ color: 'rgba(255, 255, 255, 0.5)', whiteSpace: 'nowrap' }}>info.viraap.co</p>
                                            </div>
                                        </li>
                                        <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div className="widget-info-icon">
                                                <i className="flaticon-maps-and-flags" />
                                            </div>
                                            <div className="widget-info-detail">
                                                <p style={{
                                                    color: 'rgba(255, 255, 255, 0.5)',
                                                    whiteSpace: 'nowrap',  // جلوگیری از شکسته شدن متن
                                                    textAlign: 'right'  // راست‌چین کردن متن
                                                }}>
                                                    تهران، کارگر شمالی، خیابان نهم، پلاک 82، واحد 1
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* CONTACT US */}
                            {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="widget widget_insta-gallery">
                                    <h4 className="sx-f-title">Instagram</h4>
                                    <ul>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic1.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic2.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic3.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic4.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic5.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="sx-f-insta">
                                                <NavLink to="/gallery">
                                                    <ItodoImage src="images/f-insta/pic6.jpg" alt="#" />
                                                    <i className="feather-instagram" />
                                                </NavLink>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="sx-f-bottom-section">
                    {/* <div className="sx-f-social">
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/">
                                    <i className="flaticon-facebook" />
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/">
                                    <i className="flaticon-twitter" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/">
                                    <i className="flaticon-linkedin" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/">
                                    <i className="flaticon-instagram" />
                                </a>
                            </li>
                        </ul>
                    </div> */}
                    <div className="sx-f-copy" style={{direction: 'rtl'}}>
                         تمامی حقوق متعلق به شرکت ویرا افزار پاسارگاد می باشد.© 1403 <NavLink to="/index"></NavLink> 
                    </div>
                </div>
                {/* FOOTER COPYRIGHT */}
            </footer>

        </>
    )
}

export default Footer;